import { api } from "../lib/api";

export const recommendationsService = {
  /** Heuristic rules over the user's current snapshot. */
  list: () => api.get("/recommendations").then((r) => r.data),
  /** On-demand AI advisor (uses EMERGENT_LLM_KEY). */
  aiAdvisor: () => api.post("/recommendations/ai").then((r) => r.data),
};
